import script from "./CRM01_001INS.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM01_001INS.vue?vue&type=script&setup=true&lang=js"

import "./CRM01_001INS.vue?vue&type=style&index=0&id=5d02060f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d02060f"]])

export default __exports__